
<template>
  <v-dropdown
  ref="dropdown"
  @update:opened="ddChange"
  :opened="opened"
  @open="onOpen"
  @close="onClose"
  class="formdropdown full-width">
    <template slot="display">
      <v-input 
      class="floating-label full-width"
      ref="input"
      :hasReset="hasReset && validated"
      :class="{
        active: opened || validated
      }"
      :value="(opened) ? filter : display"
      :placeholder="placeholder"
      :isReadOnly="!opened"
      @reset="reset"
      @input="onFilter"
      @focus="onFocus">
      </v-input>
    </template>
    <div slot="content"
    class="scroll_container"
    :style="{
      height: ((loading)?49:Math.min(Math.max(items.length, 1), 4)*49)+'px'
    }">
      <div 
      v-if="loading"
      class="tiny pulsar_loader"></div>
      <v-list
      v-else
      ref="list"
      @select="onSelect"
      :items="items">
        <template slot-scope="list">
          <div
          :key="list.item[list.keyField]"
          class="item"
          :class="{
            active: list.item === list.item_activated,
            selected: list.item[idKey] == value
          }"
          v-html="list.item[displayKey]">
          </div>
        </template>
      </v-list>
    </div>
  </v-dropdown>
</template>
<script>
export default {
  props: {
    value: {
      required: true
    },
    filter: {
      default: ''
    },
    display: {
      default: ''
    },
    items: {
      required: true
    },
    hasReset: {
      default: true
    },
    placeholder: {
      default: ''
    },
    min_letters: {
      default: 0
    },
    idKey: {
      default: 'id'
    },
    displayKey: {
      default: 'n'
    },
    autoOpen: {
      default: true
    },
    opened: {
      default: false
    }
  },
  data () {
    return {
      loading: false
      // dd_opened: false
    }
  },
  watch: {
    items: function () {
      this.resize()
      if (this.autoOpen) {
        this.open()
      }
    }
    // opened: function () {
      // this.open()
    // }
    // dd_opened: function (val) {
      // this.open()
      // this.$emit('update:opened', val)
    // }
  },
  computed: {
    validated: function () {
      return !!this.value
    }
  },

  methods: {
    ddChange (val) {
      this.$emit('update:opened', val)
    },

    onOpen () {
      var vm = this
      if (this.filter.length >= this.min_letters) {
        // this.opened = true
        this.$nextTick(function () {
          this.$refs.input.focus()
          // this.$emit('open')
          this.$emit('update:opened', true)
          this.refresh()
        })
      }
    },

    onClose () {
      // this.opened = false
      // this.$emit('close')
      this.$emit('update:opened', false)
    },

    refresh () {
      var vm = this
      this.$nextTick(function () {
        if (this.$refs.list) {
          this.$refs.list.resize()
        }
      })
    },

    open () {
      // if (this.$refs.dropdown) {
        // this.$refs.dropdown.open()
      // }
      this.$emit('update:opened', true)
    },

    close () {
      // if (this.$refs.dropdown) {
        // this.$refs.dropdown.close()
      // }
      this.$emit('update:opened', false)
    },

    isLoading () {
      this.loading = true
    },

    isLoaded () {
      this.loading = false
    },

    onSelect (item) {
      var vm = this
      vm.$emit('input', item[this.idKey], item)
      // console.log('onSelect')
      this.$emit('update:opened', false)
      // this.$nextTick(function () {
      //   this.close()
      // })
    },

    onFocus (e) {
      var vm = this
      setTimeout(function () {
        vm.$emit('focus', e)
      })
    },

    reset: function () {
      var vm = this
      setTimeout(function () {
        vm.$emit('input', 0, {
          id: 0,
          n: ''
        })
      })

      this.$nextTick(function () {
        this.close()
      })
    },

    resize: function () {
      if (this.$refs.list) {
        this.$refs.list.ScrollToTop()
        this.$nextTick(function () {
          this.$refs.list.resize()
        })
      }
    },

    onFilter: function (value) {
      var vm = this
      // this.input_value_tmp = this.input_value = e.target.value
      // this.opened = (e.target.value.length >= this.min_letters)
      setTimeout(function () {
        vm.$emit('filter', value)
      })
    }
  },

  mounted () {
  }

}
</script>
<style>
input:required {
  box-shadow:none;
}

/*** reset, not valid without selection ***/
.formdropdown .floating-label input:valid ~ label {
  -webkit-transform: translateY(1.7rem) scale(1);
  transform: translateY(1.7rem) scale(1);
}

.formdropdown .floating-label:not(.active) > input {
  color: transparent !important;
}

.formdropdown .floating-label.active > input ~ label,
.formdropdown .floating-label.valid > input ~ label {
  -webkit-transform: translateY(0) scale(0.8);
          transform: translateY(0) scale(0.8);
  color: #1976D2;
}

.formdropdown .floating-label .textfield:not(.no-style) {
  padding-top:1.45rem;
}
</style>
